var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.801 14.6432H30.6263V14.5827H17.5013V20.416H25.7431C24.5407 23.8117 21.3097 26.2493 17.5013 26.2493C12.6691 26.2493 8.7513 22.3315 8.7513 17.4993C8.7513 12.6672 12.6691 8.74935 17.5013 8.74935C19.7318 8.74935 21.7611 9.59081 23.3062 10.9653L27.4311 6.84039C24.8265 4.41299 21.3426 2.91602 17.5013 2.91602C9.44766 2.91602 2.91797 9.4457 2.91797 17.4993C2.91797 25.553 9.44766 32.0827 17.5013 32.0827C25.5549 32.0827 32.0846 25.553 32.0846 17.4993C32.0846 16.5215 31.984 15.5671 31.801 14.6432Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59766 10.7115L9.38901 14.2254C10.6855 11.0156 13.8253 8.74935 17.4995 8.74935C19.7301 8.74935 21.7593 9.59081 23.3044 10.9653L27.4293 6.84039C24.8247 4.41299 21.3408 2.91602 17.4995 2.91602C11.8981 2.91602 7.04036 6.07841 4.59766 10.7115Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4984 32.0824C21.2653 32.0824 24.688 30.6408 27.2758 28.2965L22.7623 24.4772C21.2489 25.6281 19.3997 26.2505 17.4984 26.249C13.7053 26.249 10.4846 23.8304 9.27125 20.4551L4.51562 24.1191C6.92917 28.842 11.8306 32.0824 17.4984 32.0824Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7997 14.6445H30.625V14.584H17.5V20.4173H25.7418C25.1666 22.0335 24.1306 23.4457 22.7617 24.4795L22.7639 24.478L27.2774 28.2974C26.958 28.5876 32.0833 24.7923 32.0833 17.5007C32.0833 16.5228 31.9827 15.5684 31.7997 14.6445Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.ea001bb11cb29e3819714e89c90279fa.svg";
export { ForwardRef as ReactComponent };